import styled from "styled-components";
import media from "styled-media-query";

export const Container = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr auto;
  grid-template-areas: 
    "image info price"
    "image buttons buttons";
  align-items: center;
  padding: 16px;
  background: white;
  border-radius: 12px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #f0f2f5;
  gap: 12px 16px;
  transition: all 0.2s ease;
  width: 100%;
  overflow: visible;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-color: #e5e7eb;
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const ProductImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: #f9fafb;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #f0f2f5;
  grid-area: image;
  
  img {
    width: 45px;
    height: 45px;
    object-fit: contain;
  }
`;

export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 100%;
  padding-right: 5px;
  grid-area: info;
`;

export const ProductName = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 6px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  line-height: 1.3;
`;

export const LicenseConfig = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: white;
  background: #0062ff;
  border: none;
  border-radius: 8px;
  padding: 6px 10px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
  width: 220px;
  height: 36px;
  
  svg {
    margin-right: 4px;
    font-size: 14px;
  }
  
  span {
    display: inline-block;
  }
  
  &:hover {
    background: #0051d6;
  }
`;

export const ProductPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  white-space: nowrap;
  font-size: 14px;
  min-width: 70px;
  grid-area: price;
  
  .old-price {
    text-decoration: line-through;
    color: #9ca3af;
    font-size: 12px;
    margin-bottom: 2px;
  }
  
  .current-price {
    font-weight: 600;
    color: #111827;
    font-size: 14px;
  }
`;

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
  max-width: 56px;
  width: 36px;
  height: 36px;
  background: #0062ff;
  color: red;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  flex-grow: 0;
  z-index: 5;
  position: relative;
  
  svg {
    width: 18px;
    height: 18px;
    paddingRight: 50px;
    margin: auto;
  }
  
  &:hover {
    background: #0051d6;
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  grid-area: buttons;
  gap: 8px;
  align-items: center;
  margin-top: 5px;
  
  ${LicenseConfig} {
    flex: 1;
  }
  
  ${RemoveButton} {
    flex: 0 0 36px;
  }
`;

export const DrawerContent = styled.div`
  .additional-license {
    padding: 15px;
    border-radius: 10px;
    background: #f9fafb;
    margin-bottom: 15px;
  }
  
  h4 {
    font-size: 16px;
    font-weight: 600;
    margin: 20px 0 15px 0;
    color: #111827;
  }
  
  .drawer-actions {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    gap: 12px;
    
    .add-license-btn {
      height: 42px;
    }
    
    .save-btn {
      height: 42px;
    }
  }
`;
